import { Component } from '@angular/core';
import { SanitizerPipe } from '../../pipes';

@Component({
    selector: 'app-account-on-hold',
    standalone: true,
    imports: [SanitizerPipe],
    templateUrl: './account-on-hold.component.html',
    styleUrl: './account-on-hold.component.scss',
})
export class AccountOnHoldComponent {}
